import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import {RequestGenerateLeaveBalanceDto} from "../dto/sf-generate-leave-balance.dto";

@Injectable()
export class SfGenerateLeaveBalanceApi {

  private service: string = '';
  private model: string = 'sfGenerateLeaveBalance';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public generateLeaveBalance(payload: RequestGenerateLeaveBalanceDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'generateLeaveBalance';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-generate-leave-balance.api.ts